import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 100%;
  flex-direction: column;
  flex-wrap: nowrap;

  overflow: hidden;
  height: 200px;
  border-radius: 4px 4px 0px 0px;
`;

export const Empty = styled.div`
  color: rgba(0, 0, 0, .6);
  text-align: center;
  padding-top: 10%;
`;
